import Link from "next/link";
import { ArrowLeftIcon } from "ui/iconsN";
import type { CustomerData } from "../../getCustomerData";
import { AccountMenu } from "./AccountMenu";
import { LogoAmis } from "./LogoAmis";
import { MenuLink } from "./MenuLink";
import { MobileMenu } from "./mobileMenu";

type Props = {
  customerData: CustomerData;
};
export const HeaderInner = ({ customerData }: Props) => {
  return (
    <div className="relative">
      <div className="h-[60px] xl:h-20 flex items-center justify-between mx-auto max-w-[calc(100%-2rem)] xl:max-w-[calc(100%-48px)] px-4 min-[1240px]:px-2 xxl:px-0 z-51">
        <div className="flex items-center gap-4 min-[1240px]:w-72 shrink-0">
          <Link
            href={{ pathname: "/", query: {} }}
            className="flex items-center gap-1.5 no-underline shrink-0 py-1 px-1.5 rounded-sm transition-colors hover:bg-white/20"
          >
            <ArrowLeftIcon className="text-tx-3" />
            <span className="text-tx-3 text-xs/[14px] font-semibold whitespace-pre-wrap">
              Revenir sur
              <br />
              Intermèdes
            </span>
          </Link>
          <div className="w-px h-12 bg-transparent min-[1240px]:bg-[#2E2825]" />
          <LogoAmis />
        </div>
        <div className="hidden min-[1240px]:flex basis-full justify-center gap-2 xxl:gap-3">
          <MenuLink href="/amis/agenda/">Agenda</MenuLink>
          <MenuLink href="/amis/themes/">Nos thèmes</MenuLink>
          <MenuLink href="/amis/conferenciers/">Nos conférenciers</MenuLink>
          <MenuLink href="/amis/replays/">Replays</MenuLink>
          {(!customerData.isConnected ||
            (customerData.subscriptionStatus === null && !customerData.hasFreeSubscription)) && (
            <MenuLink href="/amis/tarifs/">Tarifs</MenuLink>
          )}
          <MenuLink href="/amis/qui-sommes-nous/">Qui sommes-nous ?</MenuLink>
        </div>
        <div className="flex items-center shrink-0">
          <AccountMenu customerData={customerData} />
          <MobileMenu customerData={customerData} />
        </div>
      </div>
    </div>
  );
};
